export default "__VITE_ASSET__$F6eGdDH__"